import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <g clipPath="url(#clip0_1174_573)">
      <path
        d="M8 13.667C8.55215 13.667 8.99984 13.2191 9 12.667V5.74707L9.95996 6.70703C10.3505 7.09726 10.9836 7.09746 11.374 6.70703C11.7642 6.31658 11.7642 5.68343 11.374 5.29297L8.70703 2.62598L8.63086 2.55762C8.55834 2.49847 8.47922 2.45175 8.39648 2.41602C8.39354 2.41474 8.39065 2.41336 8.3877 2.41211C8.38368 2.41042 8.38001 2.40789 8.37598 2.40625C8.3458 2.39402 8.31519 2.38318 8.28418 2.37402C8.26072 2.3671 8.23671 2.36259 8.21289 2.35742C8.20672 2.35608 8.20055 2.35474 8.19434 2.35352C8.06439 2.32787 7.93064 2.32725 7.80078 2.35352C7.79652 2.35438 7.79233 2.35553 7.78809 2.35645C7.73211 2.36853 7.67668 2.38448 7.62305 2.40625C7.53295 2.44281 7.44755 2.49372 7.36914 2.55762L7.29297 2.62598L4.62598 5.29297C4.23545 5.68349 4.23545 6.31651 4.62598 6.70703C5.01651 7.09749 5.64954 7.09753 6.04004 6.70703L7 5.74707V12.667C7.00016 13.2191 7.44782 13.667 8 13.667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1174_573">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
    </defs>
  </React.Fragment>,
  'SortAscending'
)
